import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import ProductCard from "../components/ProductCard";

export default function MyPosts() {
  const { currentUser, products } = useApp();
  const myProducts = products.filter((p) => p.sellerId === currentUser?.id);

  return (
    <div style={s.page}>
      <div style={s.header}>
        <h1 style={s.heading}>Mis publicaciones</h1>
        <Link to="/new-product" style={s.btnNew}>+ Nueva publicación</Link>
      </div>
      {myProducts.length === 0 ? (
        <div style={s.empty}>
          <span style={{fontSize:56}}>📦</span>
          <p style={{fontSize:18,fontWeight:500,color:"#333"}}>Todavía no publicaste nada</p>
          <p style={{fontSize:14,color:"#888"}}>Empezá publicando tu primer producto.</p>
          <Link to="/new-product" style={s.btnNew}>Publicar ahora</Link>
        </div>
      ) : (
        <>
          <p style={{fontSize:13,color:"#888",marginBottom:16}}>{myProducts.length} publicación{myProducts.length!==1?"es":""}</p>
          <div style={s.grid}>{myProducts.map((p) => <ProductCard key={p.id} product={p} showActions />)}</div>
        </>
      )}
    </div>
  );
}

const s = {
  page:{maxWidth:1100,margin:"0 auto",padding:"32px 20px"},
  header:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24},
  heading:{fontSize:24,fontWeight:600},
  btnNew:{background:"#1D9E75",color:"#fff",padding:"10px 20px",borderRadius:10,textDecoration:"none",fontSize:14,fontWeight:500},
  grid:{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:16},
  empty:{textAlign:"center",padding:"80px 0",display:"flex",flexDirection:"column",alignItems:"center",gap:12},
};
